import React, { Component } from "react";

import PropTypes from "prop-types";
import colors from "stylesheets/utilities/colors.scss";
import SvgIcon from "components/Common/SvgIcon";
import classNames from "classnames";
import { validatePasswordAlphaNum, validatePasswordSpecialChar } from "services/validations";
import { VALID_PASSWORD_LENGTH } from "constants/passwordGuidelines";
import "./style.scss";


class PasswordGuidelines extends Component {
   /**
    * Checks if item is valid and returns green checkmark  or empty circle icon
    * @param {Boolean} validation
    * @returns {SVGIcon}
    */
   renderValidationIcon = (validation) => {
     const icon = validation ? "CircleCheckmark" : "Circle";
     const fillColor = validation ? colors.colorUIGood : colors.colorGrey2;

     return (
       <SvgIcon height={16} icon={icon} fillColor={fillColor} />
     );
   }

   /**
    * @returns {HTMLObjectElement}
    */
   render() {
     const {
       oldPassword, password, customClassName, minPasswordLength, passwordConfirm
     } = this.props;

     const validatePasswordAlphaNumeric = validatePasswordAlphaNum(password);
     const validatePasswordSpecialCharacter = validatePasswordSpecialChar(password);

     const PasswordClassNames = classNames(
       "PasswordGuidelines",
       {
         [customClassName]: customClassName
       }
     );

     return (

       <section className={PasswordClassNames}>
         <ul className="PasswordGuidelines__list">
           <li className="PasswordGuidelines__item">
             {this.renderValidationIcon(password.length >= minPasswordLength)}
             Minimum of {minPasswordLength} characters
           </li>
           <li className="PasswordGuidelines__item">
             {this.renderValidationIcon(validatePasswordAlphaNumeric)}
             One uppercase letter or number
           </li>
           <li className="PasswordGuidelines__item">
             {this.renderValidationIcon(validatePasswordSpecialCharacter)}
             One symbol
           </li>
           {oldPassword && (
             <li className="PasswordGuidelines__item">
               {this.renderValidationIcon(password !== oldPassword)}
               Doesn&#39;t match your current password
             </li>
           )}
           {passwordConfirm !== undefined && (
             <li className="PasswordGuidelines__item">
               {this.renderValidationIcon(passwordConfirm.length > 0 &&
                password === passwordConfirm)}
               Both passwords are matching
             </li>
           )}
         </ul>
       </section>

     );
   }
}

PasswordGuidelines.propTypes = {
  password: PropTypes.string.isRequired,
  minPasswordLength: PropTypes.number,
  passwordConfirm: PropTypes.string,
  oldPassword: PropTypes.string,
  customClassName: PropTypes.string
};

PasswordGuidelines.defaultProps = {
  minPasswordLength: VALID_PASSWORD_LENGTH,
  oldPassword: "",
  customClassName: "",
  passwordConfirm: undefined
};

export default PasswordGuidelines;
